// extracted by mini-css-extract-plugin
export default {"case--functionalities--listItem":"etravel--case--functionalities--listItem--1JwOd","case--functionalities--teaser":"etravel--case--functionalities--teaser--3CFNw"};